/**
 * PresentationChapterPreview React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

// application components
import PresentationFileView from "../presentation/kubus/PresentationFileView";
import PageSelection from "../base/PageSelection";
import ViewWidthScaling from "../base/ViewWidthScaling";

// application
import {selectObjectsForIds} from "../../redux/editing/selectors";
import {selectBaseStylesheet} from "../../redux/configuration/selectors";


/**
 * preview for presentation chapters
 *
 * @author Jens Gruschel
 */
class PresentationChapterPreview extends React.Component {

    state = {
        fileIndex: 0
    }

    render() {

        if (!this.props.visible) return null;

        const width = this.props.isTop ? 1080 : 300;
        const height = width * 2 * 16 / 9;

        const files = this.getFiles();
        const fileCount = files ? files.length : 0;
        const fileIndex = Math.min(this.state.fileIndex, fileCount - 1);

        const presentationFile = {
            type: "presentationfile",
            fields: {
                chapters: [this.props.object],
                title: this.props.parentFields.title,
                subheading: this.props.parentFields.subheading,
                teaser: this.props.parentFields.teaser
            }            
        };

        return <div>
            {this.props.baseStylesheet && <style>
                {this.props.baseStylesheet}
            </style>}
            <ViewWidthScaling width={width} height={height}>
                <PresentationFileView
                    presentationFile={presentationFile}
                    navigationIndex={[1, fileIndex]}
                    findReferencedObjects={this.props.findReferencedObjects}
                />
            </ViewWidthScaling>
            {fileCount > 0 && <PageSelection pageNumber={fileIndex + 1} pageCount={fileCount} onChange={(number) => this.setState({fileIndex: number - 1})} />}
        </div>;
    }

    getFiles() {
        const fields = this.props.object.fields || {};
        switch (this.props.object.type) {
            case "presentationimagechapter": return fields.image;
            case "presentationvideochapter": return fields.video;
            case "presentationinterviewchapter": return fields.video;
            default: return null;
        }
    }
}

PresentationChapterPreview.propTypes = {
    place: PropTypes.string.isRequired,
    fieldSet: PropTypes.object.isRequired,
    objectType: PropTypes.string,
    objectId: PropTypes.string,
    object: PropTypes.object,
    readOnly: PropTypes.bool,
    onObjectValueChange: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => {

    const isTop = props.place === "top";
    const visible = isTop ? props.fieldSet.id === "preview" : ["general"].includes(props.fieldSet.id);
    const elementInfo = state.editing.objectInfo[props.objectId] || {};
    const parentId = elementInfo.parentId;
    const parentObject = state.editing.objects[parentId] || {};

    return {
        isTop: isTop,
        visible: visible,
        parentFields: parentObject.fields || {},
        baseStylesheet: selectBaseStylesheet(state.configuration),
        findReferencedObjects: field => selectObjectsForIds(state.editing, field)
    }
}

export default connect(mapStateToProps)(PresentationChapterPreview);